import React from 'react'
import { useCopyToClipboard } from 'react-use'
import { notify } from '../../Helpers/Notifications'
import PropTypes from 'prop-types'

const ClickToCopy = ({ data, children }) => {
  const [, copyToClipboard] = useCopyToClipboard()

  return (
    <div
      style={{ cursor: 'pointer' }}
      onClick={() => {
        copyToClipboard(data)
        notify('success', `Copied '${data}' to clipboard.`)
      }}
    >
      {children}
    </div>
  )
}

export default ClickToCopy

ClickToCopy.propTypes = {
  data: PropTypes.string,
}
